import React from "react";
import { motion } from "framer-motion";

const services = [
  "Depression and Anxiety",
  "Trauma",
  "Grief",
  "Pre/Post Partum",
  "Old Age/Geriatric",
  "De-addiction/Withdrawal",
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export const ServicesShowcase: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-brand-50/70 to-sea-50/70 py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600">
            What We Help With
          </span>
          <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900 sm:text-5xl">
            A few things we’re great at
          </h2>
        </div>
        <motion.ul
          className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {services.map((service, index) => (
            <motion.li
              key={index}
              variants={itemVariants}
              className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-6 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-brand-200 hover:shadow-soft"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-700 transition-colors duration-300 group-hover:bg-brand-700 group-hover:text-white">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </span>
              <span className="font-semibold text-slate-800">{service}</span>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};
